import { makeStyles } from '@mui/styles';
import Card from 'apollo-react/components/Card';
import Divider from 'apollo-react/components/Divider';
import ListItem from 'apollo-react/components/ListItem';
import ListItemText from 'apollo-react/components/ListItemText';
import Popover from 'apollo-react/components/Popover';
import React from 'react';

const useStyles = makeStyles({
  divider: {
    margin: '0.5rem',
  },
  cardContent: {
    paddingTop: 8,
    maxHeight: 530,
    overflow: 'auto',
  },
});

export const ActionsButtonMenuPopover = ({ items, anchorEl, setAnchorEl }) => {
  const classes = useStyles();

  const filteredItems = items.filter((action) => !action.hidden);

  filteredItems.forEach((el, index) => {
    if (el.isDivider) {
      if (index === filteredItems.length - 1) {
        if (filteredItems[index - 1].isDivider) {
          filteredItems.splice(index - 1, index);
        } else {
          filteredItems.splice(index);
        }
      } else {
        if (filteredItems[index - 1].isDivider) {
          filteredItems.splice(index);
        }
      }
    }
  });

  return (
    <>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        PaperProps={{
          style: {
            boxShadow: '0 8px 20px 0 rgba(0, 0, 0, 0.08)',
            marginTop: 5,
          },
        }}
        onBackdropClick={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Card className={classes.cardContent}>
          {filteredItems.map((item, index) =>
            item.isDivider ? (
              <Divider className={classes.divider} key={`divider ${index}`} />
            ) : (
              <ListItem button key={item.text} disabled={item.disabled}>
                <ListItemText
                  onClick={() => {
                    item.onClick();
                    setAnchorEl(null);
                  }}
                  primary={item.text}
                />
              </ListItem>
            )
          )}
        </Card>
      </Popover>
    </>
  );
};

export default ActionsButtonMenuPopover;
